import { createFeatureSelector } from '@ngrx/store';
import { LoyaltyProgramState } from '../reducers/loyalty-program.reducer';

export const getLoyaltyProgramState =
  createFeatureSelector<LoyaltyProgramState>('loyaltyProgram');
